import React, { useEffect, useState, useContext } from "react";
import Row from "../Row";
import Column from "../Column";
import jobContext from "src/context/jobContext";
import { useLocation } from "react-router-dom";



const Table5 = ({ masouliatScore, setMasouliatScore, reload }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jobId = params.get("id");
  const [data, setData] = useState([])
  const { setGreadingScore } = useContext(jobContext)

  useEffect(() => {
    const items = JSON.parse(localStorage?.data)?.[jobId]?.masouliatAmvalVaTajhizat;
    if (items) {
      const masouliat = items[Object.keys(items)[0]];
      const masouliatData = [
        { name: "تا 50000000 ریال", score: 6, isSelected: masouliat.value == 0 },
        { name: "از 500001 تا 10000000 ریال", score: 12, isSelected: masouliat.value == 1 },
        { name: "از 1000001 تا 20000000 ریال", score: 18, isSelected: masouliat.value == 2 },
        { name: "از 2000001 تا 30000000 ریال", score: 24, isSelected: masouliat.value == 3 },
        { name: "از 30000001 ریال به بالا", score: 30, isSelected: masouliat.value == 4 },

      ]

      setData(masouliatData)

      const selectedItem = masouliatData.find((i) => i.isSelected)?.score
      setMasouliatScore(selectedItem)
      setGreadingScore((prev) => ({ ...prev, "masouliatAmvalVaTajhizat": selectedItem }))
    }
  }, [reload])






  return (
    <div>
      {/* <Row type={2}>
        <Column> میزان خسارت و ضایعه وارده احتمالی</Column>
      </Row>
      <Row type={1}>
    {data?.map((i ,index)=><Column key={index}>{i.name}</Column>
        )}
    </Row>
    <Row>
     { data?.map((i ,index)=><Column key={index}  isActive={i.isSelected}>{i.score}</Column>
      )}
      </Row> */}

      <Row type={1}>
        <Column>
          تا 50000000 ریال
        </Column>
        <Column>
          از 500001 تا 10000000 ریال
        </Column>
        <Column>
          از 10000001 تا
          20000000 ریال
        </Column>
        <Column>
          از 20000001 تا
          30000000 ریال
        </Column>
        <Column>
          از 30000001 ریال به بالا
        </Column>
      </Row>
      <Row>
        <Column isActive={masouliatScore == 6}>6</Column>
        <Column isActive={masouliatScore == 12}>12</Column>
        <Column isActive={masouliatScore == 18}>18</Column>
        <Column isActive={masouliatScore == 24}>24</Column>
        <Column isActive={masouliatScore == 30}>30</Column>
      </Row>
    </div>
  );
};

export default Table5;
